import {
  Flex,
  Group,
  Paper,
  Text,
  TypographyStylesProvider
} from "@mantine/core";
import { CommentFields } from "../types/comment.types";
import UserAvatar from "./UserAvatar";
import CommentStatusUpdate from "./CommentStatusUpdate";
import { formatDateTime } from "../lib/date-time-formatters";

import classes from './Comment.module.css';
import CommentAttachments from "./CommentAttachments";

interface CommentProps {
  comment: CommentFields;
}

export default function Comment({ comment }: CommentProps) {
  const {
    author,
    content,
    created_at,
    status_update,
    attachments
  } = comment;
  const authorName = author?.name ? author.name : author?.username;
  let statusUpdate;
  let attachmentsEl;

  if (status_update)
    statusUpdate = <CommentStatusUpdate statusUpdate={status_update} />;

  if (attachments)
    attachmentsEl = <CommentAttachments attachments={attachments} />
  
  return (
    <Paper withBorder p="sm" shadow="xs">
      <Group>
        {comment.author && <UserAvatar user={comment.author} />}
        <div>
          <Text fw={500}>{authorName}</Text>
          <Text size="xs" c="gray.7">
            {created_at && formatDateTime(created_at)}
          </Text>
        </div>
      </Group>
      <div className={classes.body}>
        <TypographyStylesProvider>
          <div dangerouslySetInnerHTML={{__html: content || ''}} />
        </TypographyStylesProvider>
        <Flex pt="md" gap="sm" align="flex-start">
          {attachmentsEl}
          {statusUpdate}
        </Flex>
      </div>
    </Paper>
  );
}